/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from "react";
import Dot from "../../../icons/Dot";
import DeleteIcon from "../../../icons/DeleteIcon";
import PencilIcon from "../../../icons/PencilIcon";
import MapPin from "../../../icons/MapPin";
import CaretDown from "../../../icons/CaretDown";
import useDimensions from "../../../hoc/useDimensions";
import ChevronUpSvg from "../../../icons/ChevronUpSvg";
import { useRouter } from "next/router";
import { deletePYPDataByUuid, getWatermarkedImgixUrl } from "services";
import { Button } from "../../../shadcn/components/ui/button";

// success tagStyle ="bg-[#F2FFEA]"

interface PropertyCardProps {
  assetPath: string;
  className?: string;
  imgClasses?: string;
  showPrice: boolean;
  price: string | number;
  priceTag: string;
  listingId: string;
  location: string;
  propertyType: string;
  carpetArea: string;
  deadlineDate: string;
  auctionDate: string;
  propertyInfo: string;
  propertyData: any;
  isTagged?: boolean;
  tag?: string;
  tagStyle?: string;
  tagNumber?: any;
  tagText?: any;
  showTagText: boolean;
}

export default function PostedPropertyCard({
  assetPath,
  className,
  imgClasses,
  showPrice = true,
  price,
  priceTag,
  listingId,
  location,
  propertyType,
  carpetArea,
  deadlineDate,
  auctionDate,
  propertyInfo,
  tag,
  tagStyle,
  tagNumber,
  tagText,
  showTagText = true,
  isTagged = true,

  propertyData,
}: PropertyCardProps) {
  const router = useRouter();
  const [showMore, setShowMore] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isTextExceeded, setIsTextExceeded] = useState(false);

  const [maxLength, setMaxLength] = useState(60);
  const { ref, dimensions } = useDimensions();

  useEffect(() => {
    if (modalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [modalOpen]);

  useEffect(() => {
    const maxTextLength =
      dimensions.width > 900 ? 105 : dimensions.width > 357 ? 55 : 48;
    setMaxLength(maxTextLength);
    setIsTextExceeded(propertyInfo?.length > maxTextLength);
  }, [dimensions, propertyInfo?.length]);

  if (!dimensions) return null;

  const toggleShowMore = () => setShowMore((prev) => !prev);

  const handleEditClick = () => {
    window.open(`/post-your-property/${propertyData?.uuid}`, "_blank");
  };

  const handleDeleteClick = () => {
    const deletefunction = async () => {
      try {
        const response = await deletePYPDataByUuid(propertyData.uuid);

        if (response) {
          console.log("res", response);

          router.reload();
        }
      } catch (err) {
        console.log("error", err);
      }
    };
    deletefunction();
  };

  return (
    <div>
      <section
        className={`${"hover:drop-shadow-lg hover:scale-[1.001]   hover:duration-300 hover:ease-out hover:cursor-pointer"}`}
      >
        <main
          onClick={() => {
            if (tag === "approved" && propertyData?.property_listing_id)
              window.open(
                `/private-properties/${propertyData?.property_listing_id}`,
                "_blank",
              );
          }}
          ref={ref}
          className={
            className
              ? className
              : "bg-brand-lightPink flex flex-col md:flex-row max-w-[358px] md:max-w-[951px] 2xl:lg:max-w-[1251px] lg:relative   clip-path-mobileClipPolygonTopRight md:clip-path-webClipPolygonTopRight"
          }
        >
          <section className="relative cursor-pointer">
            <img
              src={
                propertyData?.json_form_data?.propertyPhotos?.length > 0
                  ? getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${propertyData?.json_form_data?.propertyPhotos[0].id}`,
                    )
                  : assetPath
              }
              alt="property image"
              className={`w-full md:w-[260px]  h-[177px] md:h-[200px] z-0 ${imgClasses}`}
            />
            {isTagged && (
              <div className="absolute bottom-0 left-0 z-10 bg-gradient-to-t from-black to-[#00000000] w-full pt-4 pb-3 lg:pt-8">
                {tag && (
                  <div
                    className={`ml-2 pl-1 pr-5 text-xs font-openSans font-semibold uppercase bg-[#F1EAFF] justify-self-start py-[2px] ${tagStyle}`}
                    style={{
                      clipPath:
                        "polygon(0% 0%, 85% 0%, 100% 100%, 100% 100%, 0% 100%)",
                    }}
                  >
                    {tag}
                  </div>
                )}
              </div>
            )}
            <div className="absolute right-[37px] top-[10px] z-10 lg:hidden cursor-pointer">
              <div className="flex space-x-2">
                <div
                  onClick={handleEditClick}
                  className="bg-white md:hidden  p-1 w-8 h-8 rounded-sm flex justify-center items-center"
                >
                  <PencilIcon />
                </div>
                <div
                  onClick={(event) => {
                    event.stopPropagation();
                    setModalOpen(true);
                  }}
                  className="bg-white p-1 md:hidden rounded-sm w-8 h-8 "
                >
                  <DeleteIcon />
                </div>
              </div>
            </div>
          </section>

          <section className="py-4 lg:py-4 px-3 lg:px-0 lg:pl-5 lg:flex-1 lg:pr-[51px]">
            <div
              className={`flex items-center ${
                showPrice ? "justify-between" : "justify-end"
              } lg:pr-10`}
            >
              {showPrice && (
                <div className="flex items-center">
                  <span className="font-openSans font-semibold text-xl lg:text-2xl leading-normal text-brand-textBlack">
                    ₹{price}
                  </span>
                  <span className="font-openSans font-semibold text-[10px] lg:text-xs leading-normal uppercase text-brand-headingBlue pl-[6px] lg:pl-[10px] mt-[5px] lg:mt-0">
                    {priceTag}
                  </span>
                </div>
              )}
              <div className="py-1 px-3 lg:px-4 border-[0.5px] rounded-full border-brand-textLightGrey flex items-center">
                <Dot />
                <span className="text-[10px] lg:text-sx font-openSans pl-3 font-normal text-brand-textBlack">
                  {propertyData?.property_listing_id
                    ? `ID ${propertyData?.property_listing_id}`
                    : propertyData?.listing_id
                    ? `Temp ID ${propertyData?.listing_id}`
                    : ""}
                </span>
              </div>
              <div className="flex">
                <div onClick={handleEditClick}>
                  <PencilIcon className="hidden md:flex ml-6" />
                </div>
                <div
                  onClick={(event) => {
                    event.stopPropagation();
                    setModalOpen(true);
                  }}
                >
                  <DeleteIcon className="hidden md:flex ml-2 " />
                </div>
              </div>
            </div>

            <div className="flex pt-[10px] lg:pt-[6px] lg:items-center">
              <MapPin />
              <span className="px-1 font-openSans text-xs lg:text-sm text-brand-textLightGrey font-normal capitalize">
                {location}
              </span>
              <ul className="list-disc pl-4 lg:pl-6 font-openSans text-xs lg:text-sm text-brand-textLightGrey font-normal capitalize">
                <li>{propertyType}</li>
              </ul>
            </div>

            <div className="pt-[21px] lg:pt-[19px] lg:max-w-[413px] flex">
              <div className="border-r-[1px] border-brand-borderGrey flex-[10] flex flex-col justify-start">
                <div>
                  <h4 className="font-openSans text-[10px] lg:text-xs text-brand-textLightGrey font-normal leading-normal">
                    Area
                  </h4>
                  <p className="font-openSans text-[10px] lg:text-xs font-semibold text-brand-textBlack leading-normal mt-1">
                    {carpetArea}
                  </p>
                </div>
              </div>

              <div className="border-r-[1px] border-brand-borderGrey flex-[13] flex items-center justify-center">
                <div>
                  <h4 className="font-openSans text-[10px] lg:text-xs text-brand-textLightGrey font-normal leading-normal">
                    Deadline Date
                  </h4>
                  <p className="font-openSans text-[10px] lg:text-xs text-brand-textBlack font-semibold leading-normal mt-1">
                    {deadlineDate}
                  </p>
                </div>
              </div>

              {auctionDate && (
                <div className="flex-[10] flex justify-end">
                  <div>
                    <h4 className="font-openSans text-[10px] lg:text-xs text-brand-textLightGrey font-normal leading-normal">
                      Auction Date
                    </h4>
                    <p className="font-openSans text-[10px] lg:text-xs text-brand-textBlack font-semibold leading-normal mt-1">
                      {auctionDate}
                    </p>
                  </div>
                </div>
              )}
            </div>

            <div className="mt-[22px] lg:mt-[21px] flex items-start relative">
              <p
                className={`text-[10px] font-normal text-brand-textLightGrey leading-4 tracking-wide capitalize`}
              >
                {isTextExceeded && !showMore
                  ? `${propertyInfo.substring(0, maxLength)}...`
                  : !isTextExceeded
                  ? propertyInfo
                  : `${propertyInfo.substring(0, maxLength)}...`}
              </p>
              <div
                className={`text-[10px] font-normal text-brand-textLightGrey leading-4 tracking-wide capitalize bg-white p-2 lg:p-4 rounded-lg ${
                  isTextExceeded && showMore ? "" : "hidden"
                } flex absolute items-center lg:items-start -top-10 lg:-top-12 ml-0 lg:ml-4 break-normal shadow-sm`}
              >
                <span>{isTextExceeded && showMore && propertyInfo}</span>
                {isTextExceeded && (
                  <span
                    onClick={() => setShowMore(false)}
                    className="cursor-pointer p-1 lg:p-2 bg-[#EEE] rounded-full"
                  >
                    <ChevronUpSvg width={16} height={16} />
                  </span>
                )}
              </div>
              {isTextExceeded && !showMore && (
                <span onClick={toggleShowMore} className="cursor-pointer ">
                  <CaretDown />
                </span>
              )}
            </div>
          </section>
        </main>
      </section>{" "}
      {modalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-20">
          <div className="bg-white px-8 py-6 rounded-lg shadow-lg flex flex-col items-center space-y-4">
            <p className="font-openSans font-semibold text-mobile-body-md lg:text-web-body-lg leading-4  lg:leading-[30px]">
              {" "}
              Are you sure you want to remove this property application ?
            </p>

            <div className="flex space-x-5">
              <Button
                className="mt-4 px-8 py-0 bg-brand-bgBlack text-[12px] text-white rounded-md"
                onClick={handleDeleteClick}
              >
                Yes
              </Button>
              <Button
                className="mt-4 px-8 py-0 bg-white text-[12px] hover:text-white text-brand-bgBlack border rounded-md"
                onClick={() => setModalOpen(false)}
              >
                No
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
